<template>
  <Dialog
    :visible="visible"
    :draggable="false"
    header="Trabalho em uso"
    :style="{ width: '520px' }"
    :breakpoints="{ '575px': '92vw' }"
    :modal="true"
    @update:visible="emit('update:visible', $event)"
  >
    <div class="flex flex-column gap-3 line-height-3">
      <p class="m-0">
        <strong>{{ editandoPor || "Outra pessoa" }}</strong> está editando este
        trabalho no momento.
      </p>
      <p class="m-0">
        Para evitar conflitos ou perda de alterações, apenas uma pessoa pode
        editar o trabalho por vez. Essa regra vale para todos os alunos do grupo
        e para o orientador.
      </p>
      <p class="m-0">
        A edição será liberada automaticamente quando a pessoa sair do trabalho.
        Se houver perda de conexão, a liberação poderá levar até 2 minutos.
      </p>
    </div>
    <template #footer>
      <template v-if="antesDeAbrir">
        <Button
          label="Voltar"
          severity="secondary"
          outlined
          @click="emit('update:visible', false)"
        />
        <Button
          label="Abrir para leitura"
          icon="pi pi-eye"
          autofocus
          @click="emit('abrir')"
        />
      </template>
      <Button
        v-else
        label="Entendi"
        autofocus
        @click="emit('update:visible', false)"
      />
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import Button from "primevue/button";
import Dialog from "primevue/dialog";

defineProps<{
  visible: boolean;
  editandoPor: string | null;
  /** No card, antes de entrar: oferece voltar ou abrir para leitura. */
  antesDeAbrir?: boolean;
}>();

const emit = defineEmits<{
  "update:visible": [value: boolean];
  abrir: [];
}>();
</script>
